/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type LinkedInMessageTaskCreatePriority = typeof LinkedInMessageTaskCreatePriority[keyof typeof LinkedInMessageTaskCreatePriority];


export const LinkedInMessageTaskCreatePriority = {
  urgent: 'urgent',
  high: 'high',
  medium: 'medium',
  low: 'low',
} as const;
